import React from "react";
import { ArrowLeftIcon, ArrowRightIcon } from "lucide-react";
import { formatEuro } from "../utils/pricing";
import type { Quote } from "../types/configurator";
interface ConfiguratorFooterProps {
  isFirst: boolean;
  isLast: boolean;
  canContinue: boolean;
  quote: Quote | null;
  quantity: number;
  hint: string;
  onBack: () => void;
  onNext: () => void;
}
export function ConfiguratorFooter({
  isFirst,
  isLast,
  canContinue,
  quote,
  quantity,
  hint,
  onBack,
  onNext
}: ConfiguratorFooterProps) {
  return <footer className="sticky bottom-0 z-30 border-t border-line bg-paper" data-id="element-1" data-mp="3cwbbodecj0j8">
      <div className="flex h-[72px] items-stretch" data-id="element-2" data-mp="3rmqx9taocahx">
        <button type="button" onClick={onBack} disabled={isFirst} className="flex shrink-0 items-center gap-2 border-r border-line px-5 text-sm font-bold transition-colors duration-150 ease-out hover:bg-mist disabled:cursor-not-allowed disabled:text-muted/50 disabled:hover:bg-paper md:px-8" data-id="element-3" data-mp="3rlfqrlpugon4">
          <ArrowLeftIcon size={16} aria-hidden="true" data-id="element-4" data-mp="1t57a5f7bt1gi" />
          Retour
        </button>

        <div className="flex min-w-0 flex-1 items-center px-5 md:px-8" data-id="element-5" data-mp="1y3ikdr1j9dz9">
          {quote ? <div className="min-w-0" data-id="element-6" data-mp="232v8sg81yt3y">
              <p className="truncate text-xs text-muted" data-id="element-7" data-mp="231twy9j7q2l6">Estimation HT · {quantity} pièces</p>
              <p className="text-lg font-bold tabular-nums md:text-xl" data-id="element-8" data-mp="282zmxzlhnbr0">
                {formatEuro(quote.total)}
                <span className="ml-2 text-sm font-normal text-muted" data-id="element-9" data-mp="2c2rwofmmbnxy">soit {formatEuro(quote.unitTotal)} / pièce</span>
              </p>
            </div> : <p className="truncate text-sm text-muted" data-id="element-10" data-mp="2lstg2u410i6j">{hint}</p>}
        </div>

        {isLast ? <button type="submit" form="quote-form" className="flex shrink-0 items-center gap-2 bg-ink px-6 text-sm font-bold text-paper transition-colors duration-150 ease-out hover:bg-cherry md:px-10" data-id="element-11" data-mp="2qred6knzelqr">
            Envoyer ma demande
            <ArrowRightIcon size={16} aria-hidden="true" data-id="element-12" data-mp="10nuokzs5ilst" />
          </button> : <button type="button" onClick={onNext} disabled={!canContinue} className="flex shrink-0 items-center gap-2 bg-ink px-6 text-sm font-bold text-paper transition-colors duration-150 ease-out hover:bg-cherry disabled:cursor-not-allowed disabled:bg-mist disabled:text-muted md:px-10" data-id="element-13" data-mp="vpjdymu1879j">
            Continuer
            <ArrowRightIcon size={16} aria-hidden="true" data-id="element-14" data-mp="1jgygaflt6oks" />
          </button>}
      </div>
    </footer>;
}